<template>
  <i-form-item label="Document">
    <a :href="`/documents/${document.id}`">
      <FFIcon
        type="file"
        style="font-size:18px; color: #3399ff; margin-right:6px;"
        aria-hidden="true"
      />
      {{ document.name }} </a
    >&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
    <a :href="`/upload/files/${document.filename}`" target="_blank">
      <FFIcon
        type="download"
        style="font-size:18px; color: #3399ff; margin-right:6px;"
        aria-hidden="true"
      />
      {{ document.original_filename || document.filename }}
    </a>
  </i-form-item>
</template>

<script>
import database from "@/database";

export default {
  props: ["id"],
  data() {
    return {
      document: {},
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    id() {
      this.load();
    },
  },
  methods: {
    // Load initial value
    load() {
      if (this.id > 0) {
        database
          .load("documents", this.id)
          .then(response => {
            this.document = response.data || {};
          })
          .catch(error => {
            console.error(error.response);
          });
      }
    },
  },
};
</script>
